import { useState, useEffect } from "react";
import { apiUrl } from "utils/api";

const useAllFlashProducts = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [loading1, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        // const response = await fetch(`/api/getAllProduct`);
        const response = await fetch(apiUrl("getAllFlashProduct"));
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setAllProducts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAllProducts();
  }, []);

  return { allProducts, loading1, error };
};

export default useAllFlashProducts;
